import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SecureBlobPipe } from 'src/app/core/pipes/secure-blob.pipe';
import { isPublicImageUrl } from 'src/app/core/helpers/public-image-url.helper';
import { throwError } from 'rxjs';
import { ResourcesEndpointEnum } from 'src/app/core/enums/resources-endpoint.enum';
import { ReportConfig } from 'src/app/core/interfaces/report-config';
import { ResourceService } from 'src/app/core/services/resource.service';
import { IonicModule, PopoverController } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { ConfigurationPopoverComponent } from '../popovers/configuration-popover/configuration-popover.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RequiredRolesDirective, DirectiveCondition, DirectiveRole } from 'src/app/core/directives/required-roles.directive';
import { GroupInterface } from 'src/app/core/interfaces/group.interface';

@Component({
    selector: 'app-report-card',
    templateUrl: './report-card.component.html',
    styleUrls: ['./report-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    IonicModule,
    RouterLink,
    TranslateModule,
    RequiredRolesDirective,
    SecureBlobPipe,
    AsyncPipe
]
})

export class ReportCardComponent implements OnInit {
  @Input()
  report!: ReportConfig;
  @Input()
  groupId!: number;
  @Input()
  onMobileView: boolean = false;
  @Input()
  group?: GroupInterface;
  @Input()
  collapsableTitle?: string;
  @Input()
  portalVersion?: string;
  isPremium = false;
  descriptionPopoverOpen = false;

  isPublicLogoUrl(url: string | undefined | null): boolean {
    return isPublicImageUrl(url);
  }
  DirectiveRole = DirectiveRole;
  DirectiveCondition = DirectiveCondition;

  @ViewChild('descriptionPopover') descriptionPopover!: HTMLIonPopoverElement;

  constructor(private resourceService: ResourceService,
    private toastrService: ToastrService,
    private popoverController: PopoverController,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void { }

  setAsFavorite(event: any, report: ReportConfig) {
    event.stopPropagation();
    event.preventDefault();

    this.resourceService.put<any>(ResourcesEndpointEnum.PUT_REPORT_FAVORITE, {}, { reportID: report.ReportID })
      .subscribe({
        next: () => {
          report.UsersFavorite = !report.UsersFavorite;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.translateService.get('Error when toggling favorite report').subscribe(t => {
            this.toastrService.error(t);
          })
          throwError(() => err);
        },
        complete: () => { }
      });
  }

  openDescriptionPopover(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.descriptionPopover.event = event;
    this.descriptionPopoverOpen = true;
  }
}
